import { CURRENCIES } from "./constants";

export const XAU_TO_GAU = 31.1034768;

export type ExchangeDataType = Record<string, number>

export type ParsedExchangeDataType =
  & { GAU:number } 
  & { [k in typeof CURRENCIES[number]]: number };

export const fawazahmed0_urls = (YYYY_MM_DD: string) => [
  `https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@${YYYY_MM_DD}/v1/currencies/xau.min.json`,
  `https://${YYYY_MM_DD}.currency-api.pages.dev/v1/currencies/xau.min.json`, // fallback
];

export const fetchXauToAllCurrenciesForDay = async (YYYY_MM_DD: string): Promise<ExchangeDataType | null> => {
  let errors = [];
  if (YYYY_MM_DD < "2024-03-02") {
    // make sure these are already generated.
    errors.push(
      new Error(`${YYYY_MM_DD} isn't supported via API (too old).`)
    );
  } else {
    // use fawazahmed0
    for (const u of fawazahmed0_urls(YYYY_MM_DD)) {
      try {
        const res = await fetch(u);
        if (!res.ok) {
          errors.push(res);
          continue;
        }
        const { xau } = await res.json(); // 1 XAU (troy oz) = xau.usd USD, etc.
        return xau;
      } catch (err) {
        errors.push(err);
      }
    }
  }
  console.warn(`Failed to fetch ${YYYY_MM_DD}, errors:`);
  errors.forEach((e,i) => console.warn(`#${i+1}:`, e));
  return null;
}

export const fetchGauToSelectedCurrenciesForToday = async (): Promise<Partial<ParsedExchangeDataType>> => {
  let d = new Date();
  let xauToAllCurrencies = null;
  for (let i = 0 ; i < 10; ++ i) { // allow upto 10 day older
    const day = d.toISOString().slice(0,10);
    // check local storage.
    if ("localStorage" in globalThis && globalThis.localStorage) {
      try {
        const cached = globalThis.localStorage.getItem(`GAU-RATES_${day}`);
        if (cached) {
          return JSON.parse(cached) as Partial<ParsedExchangeDataType>;
        }
      } catch (err) {
        console.warn('bad value in local storage', err);
      }
    }
    xauToAllCurrencies = await fetchXauToAllCurrenciesForDay(day);
    if (xauToAllCurrencies) break;
    d.setUTCDate(d.getUTCDate() + 1);
  }
  if (!xauToAllCurrencies) {
    console.error('Conversion API not working.');
    return { GAU: 1 };
  }
  const day = d.toISOString().slice(0,10);
  const res: Partial<ParsedExchangeDataType> = { GAU: 1 };
  CURRENCIES.forEach((currency) => {
    const xauToCurrency = xauToAllCurrencies[currency.toLowerCase()];
    if (xauToCurrency) {
      res[currency] = xauToCurrency / XAU_TO_GAU;
    }
  })
  if ("localStorage" in globalThis && globalThis.localStorage) {
    globalThis.localStorage.setItem(`GAU-RATES_${day}`, JSON.stringify(res));
  }
  return res;
}